import { Autocomplete, CircularProgress, Skeleton } from '@mui/material'
import TextField from '@mui/material/TextField'
import * as React from 'react'
import { AugmentedControllerRenderProps } from '../steps/hooks'
import { useTranslation } from 'react-i18next'
import { SalesPerson } from '../../api/interfaces'

export interface SalesPersonSelectProps extends AugmentedControllerRenderProps {
    value: string
    salesPersons: SalesPerson[]
}

export const SalesPersonSelect = React.forwardRef((props: SalesPersonSelectProps, ref) => {
    const { t } = useTranslation()
    const completeOptions = props.salesPersons.length > 0
        ? [{'id': '', 'label': t('EmailConfirmation.salesPerson.noContactOption')}, ...props.salesPersons]
        : []
    const optionIds = completeOptions.map(item => item.id)
    const optionLabel = (option: string) => {
        const selectedOptions = completeOptions.filter(item => item.id === option)
        return selectedOptions && selectedOptions.length > 0 ? selectedOptions[0].label : ''
    }

    return (
        <Autocomplete
            blurOnSelect={true}
            onChange={(e, newValue) => {
                if (props.onChange) {
                    props.onChange(newValue)
                }
            }}
            onBlur={e => props.onBlur()}
            value={props.value}
            options={optionIds}
            getOptionLabel={optionLabel}
            autoHighlight
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={props.label}
                    helperText={props.helperText}
                    error={props.error}
                    inputProps={{
                        ...params.inputProps,
                        autoComplete: 'new-password', // disable autocomplete and autofill
                    }}
                />
            )}
        />
    )
})
